import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';

const { WHITE, GREY, LIGHT_GRAY_SHADE, FONT_COLOR, LIGHT_HIGHLIGHT } = colors;

const dashboardToastStyles = makeStyles(() => ({
	filterByPadding: {
		paddingLeft: 12,
		paddingTop: 0,
		paddingBottom: 0,
		marginBottom: 0
	},
	root: {
		color: WHITE,
		backgroundColor: GREY
	},
	text: {
		marginBottom: 'auto',
		marginTop: 'auto',
		paddingRight: 8,
		paddingTop: 2,
		paddingLeft: 24,
		'&:hover': {
			backgroundColor: LIGHT_HIGHLIGHT,
			borderRadius: '20px'
		}
	},
	panel: {
		borderRadius: 6
	},
	paper: {
		padding: 8,
		display: 'inline',
		backgroundColor: 'white'
	},
	list: {
		display: 'flex',
		justifyContent: 'flex-start',
		listStyleType: 'none',
		paddingBottom: 0,
		paddingTop: 0,
		marginTop: 8,
		marginLeft: 8
	},
	item: {
		backgroundColor: LIGHT_GRAY_SHADE,
		color: FONT_COLOR,
		marginLeft: 4,
		marginRight: 4,
		marginTop: 8,
		marginBottom: 8,
		padding: 0,
		borderRadius: '20px',
		maxWidth: 'fit-content',
		height: '24px',
		'&:hover': {
			backgroundColor: LIGHT_HIGHLIGHT,
			borderRadius: '20px'
		}
	},
	chip: {
		fontSize: 16,
		fontWeight: 300,
		color: FONT_COLOR,
		margin: '4px 0x 0px 4px',
		padding: 0,
		borderRadius: '20px',
		maxWidth: 'fit-content',
		height: '24px',
		'&:hover': {
			backgroundColor: LIGHT_HIGHLIGHT,
			borderRadius: '20px'
		}
	}
}));

export default dashboardToastStyles;
